import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Slider from "react-slick";
import toast from "react-hot-toast";

import Logout from "../../common/Logout";
import CustomButton from "../../common/CustomButton";
import PaddedContentArea from "../../common/PaddedContentArea";

import Intro from "./components/Intro";
import Details from "./components/Details";
import Goals from "./components/Goals";
import SurveyCard from "./components/SurveyCard";
import SurveyProgressIndicator from "./components/SurveyProgressIndicator";
import LoadingAnimation from "../../common/LoadingAnimation";

import { delay } from "../../utils";
import { SubmitAnswers } from "../../redux/v2/user/actions";
import { CheckRequirementsAndRedirect } from "../../redux/v2/user/actions";
import { LoadUserData, GetSurveyHistory, LoadAccountDetails } from "../../redux/v2/user/actions";

import "./style.css";

function GettingStarted(props) {
    const navigate = useNavigate();

    const bypass = new URLSearchParams(window.location.search).get("bypass") || props?.bypass;
    const { surveyQuestions, user } = props.User;
    const redo = localStorage.getItem("indi-redo-survey");
    const redoType = bypass ? "full" : localStorage.getItem("indi-redo-type");
    const [page, setPage] = useState(0);
    const [showButtons, setShowButtons] = useState(false);
    const [enableNext, setEnableNext] = useState(false);
    const sliderRef = useRef(null);
    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: page,
        adaptiveHeight: true,
    };
    const buttonHidden = redo ? [0] : [0, 1];
    let limit = !redo ? 10 : redoType == "full" ? 9 : 3;
    let progress = Math.round(((page - (redo ? 1 : 2)) / (limit - (redo ? 0 : 1))) * 100);

    // useEffect(() => {
    //     if (!bypass) {

    //         if ((localStorage.getItem("requirement_status") == 3 || user.requirement_status == 3) && !redo) {
    //             navigate("/home");
    //         }
    //     }

    //     // props.GetSurveyHistory();
    // }, []);

    useEffect(() => {
        sliderRef?.current?.slickGoTo(page);
    }, [page]);

    useEffect(() => {
        setEnableNext(false);
        if (buttonHidden.indexOf(page) != -1) {
            setShowButtons(false);
        }
    }, [page]);

    const back = () => {
        sliderRef?.current?.slickGoTo(page - 1);
        setPage(page - 1);
    };

    const next = async (leap = 1) => {
        if (page < limit) {
            sliderRef?.current?.slickGoTo(page + leap);
            setPage(page + leap);
        } else {
            const toastId = toast.loading("Completing Survey...");

            const res = await props.SubmitAnswers(redo, redoType);
            if (res.success) {

                // await props.LoadAccountDetails();
                toast.success("Successful.", {
                    id: toastId,
                });

                if (redo) {
                    navigate("/");
                } else {
                    navigate("/program-introduction");
                }
            } else {
                toast.error("Failed.", {
                    id: toastId,
                });
            }
        }
    };


    return (
        <>
            <Logout showLogo />

            <div id="getting-started-v2" className="flex-c content-area">
                <div id="getting-started-v2-wrapper">
                    <PaddedContentArea>
                        {buttonHidden.indexOf(page) == -1 && <SurveyProgressIndicator progress={progress} />}

                        <Slider {...settings} ref={sliderRef}>
                            <div>
                                <Intro
                                    next={() => {
                                        if (redo) {
                                            delay(() => {
                                                setShowButtons(true);
                                            }, 300);
                                        }

                                        next();
                                    }}
                                    redo={redo}
                                    redoType={redoType}
                                    bypass={bypass}
                                />
                            </div>

                            {/* {
                                !redo &&
                                <div>
                                    <Details next={next} />
                                </div>
                            } */}

                            {!redo && (
                                <div>
                                    <Goals
                                        isShown={!redo && page == 1}
                                        next={() => {
                                            delay(() => {
                                                setShowButtons(true);
                                            }, 300);

                                            next();
                                        }}
                                    />
                                </div>
                            )}

                            {surveyQuestions.length > 0 ? (
                                surveyQuestions.map((sq, i) => {
                                    return (
                                        <div>
                                            <SurveyCard survey={sq} index={i} setEnableNext={setEnableNext} />
                                        </div>
                                    );
                                })
                            ) : (
                                <div>
                                    <div className="flex-c" style={{ height: "300px", paddingTop: "100px" }}>
                                        <LoadingAnimation />
                                    </div>
                                </div>
                            )}
                        </Slider>

                        {buttonHidden.indexOf(page) == -1 && surveyQuestions.length > 0 && showButtons ? (
                            <div id="gs-v2-control-buttons">
                                <div id="gs-v2-control-buttons-wrapper">
                                    <CustomButton
                                        isPrimary={false}
                                        onClick={() => {
                                            back();
                                        }}
                                    >
                                        Back
                                    </CustomButton>
                                    <CustomButton
                                        disabled={!enableNext}
                                        onClick={() => {
                                            next();
                                        }}
                                    >
                                        Next
                                    </CustomButton>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </PaddedContentArea>
                </div>
            </div>

        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    SubmitAnswers,
    CheckRequirementsAndRedirect,
    LoadUserData,
    GetSurveyHistory,
    LoadAccountDetails,
})(GettingStarted);
